import {
  type ReactNode,
  createContext,
  useState,
  Dispatch,
  SetStateAction,
  useContext,
} from 'react'

interface AuthContextValue {
  isBalanceVisible: boolean
  setIsBalanceVisible: Dispatch<SetStateAction<boolean>>
}

const BalanceContext = createContext({} as AuthContextValue)

export function BalanceProvider({ children }: { children: ReactNode }) {
  const [isBalanceVisible, setIsBalanceVisible] = useState(true)

  return (
    <BalanceContext.Provider value={{ isBalanceVisible, setIsBalanceVisible }}>
      {children}
    </BalanceContext.Provider>
  )
}

export function useBalance() {
  return useContext(BalanceContext)
}
